import { SearchDto } from "../../model/search/dto/SearchDto";
import { SearchResponseDto } from "../../model/search/dto/SearchResponseDto";
import { AtiraApi } from "../AxiosClient";

export class AppAxios {
  static async search(dto: SearchDto) {
    return AtiraApi.post<SearchResponseDto>(`/search`, dto).then(
      ({ data }) => data,
    );
  }
}
